import Vue from 'vue'
import Router from 'vue-router'
// import { getToken } from '../utils/cookie'
import store from '../store'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '首页',
      redirect: '/homepage'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/Login')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/login/Register')
    },
    {
      path: '/homepage',
      name: 'homepage',
      component: () => import('@/views/home')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/views/otherMain/BaseSection')
    },
    {
      path: '/specialty',
      name: 'specialty',
      component: () => import('@/views/otherMain/Specialty')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/otherMain/About')
    },
    {
      path: '/capital',
      name: 'capital',
      component: () => import('@/views/otherMain/BaseSection')
    },
    {
      path: '/operation',
      name: 'operation',
      component: () => import('@/views/otherMain/BaseSection')
    },
    {
      path: '/tutor',
      name: 'tutor',
      component: () => import('@/views/otherMain/Tutor')
    },
    {
      path: '/tutorDetail',
      name: 'tutorDetail',
      component: () => import('@/views/detailPage/TutorDetail')
    },
    {
      path: '/activityMain',
      name: 'activityMain',
      component: () => import('@/views/detailPage/ActivityMain')
    },
    {
      path: '/activityDetail',
      name: 'activityDetail',
      component: () => import('@/views/detailPage/ActivityDetail')
    },
    {
      path: '/courseMain',
      name: 'courseMain',
      component: () => import('@/views/detailPage/CourseMain')
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      component: () => import('@/views/detailPage/CourseDetail')
    },
    {
      path: '/informationDetail',
      name: 'informationDetail',
      component: () => import('@/views/detailPage/InformationDetail')
    },
    {
      path: '/informationMain',
      name: 'informationMain',
      component: () => import('@/views/detailPage/InformationMain')
    },
    {
      path: '/searchResult',
      name: 'searchResult',
      component: () => import('@/views/home/SearchResult')
    },
    {
      path: '/userCenter',
      name: 'userCenter',
      component: () => import('@/views/userCenter')
    },
    {
      path: '/apply',
      name: 'apply',
      component: () => import('@/views/mobilePage/Apply')
    },
    {
      path: '/survey',
      name: 'survey',
      component: () => import('@/views/mobilePage/Survey')
    },
    {
      path: '/signIn',
      name: 'signIn',
      component: () => import('@/views/mobilePage/SignIn')
    }
  ]
})

router.beforeEach(async(to, from, next) => {
  if (!to.query.position) {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  const hasToken = true
  if (to.path === '/userCenter' && !hasToken) {
    store.commit('setUserData', '')
    this.$message({
      message: '请重新登录  !',
      offset: 120,
      type: 'warning'
    })
    next({ path: '/' })
  } else {
    next()
  }
})
router.onError((error) => { // 处理360浏览器连续刷新不发请求问题
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

export default router
